import React from 'react';

const STYLES = {
  privato: { bg: 'bg-[var(--vc-payer-privato-bg)]', fg: 'text-[var(--vc-payer-privato-fg)]', label: 'Privato' },
  fondo: { bg: 'bg-[var(--vc-payer-fondo-bg)]', fg: 'text-[var(--vc-payer-fondo-fg)]', label: 'Fondo' },
  ssn: { bg: 'bg-[var(--vc-payer-ssn-bg)]', fg: 'text-[var(--vc-payer-ssn-fg)]', label: 'SSN' }
};

export function PayerTag({ payer = 'privato', label, className = '' }) {
  const key = String(payer || 'privato').toLowerCase();
  const cfg = STYLES[key] || STYLES.privato;
  return (
    <span
      className={`inline-flex items-center rounded-vc-sm px-2 py-0.5 text-vc-xs font-medium ${cfg.bg} ${cfg.fg} ${className}`}
    >
      {label || cfg.label}
    </span>
  );
}
